import { connect } from "react-redux";
import { Creators, getExporting } from "../../reducer";
import ExportCsvButton from "./ExportCsvButton";

export default connect(
  state => ({
    exporting: getExporting(state),
    locations: state.data.locations,
  }),
  dispatch => ({
    onExport: (filters, locations) => dispatch(Creators.exportCustomer(filters, locations))
  })
)(ExportCsvButton);



// WEBPACK FOOTER //
// ./src/customer/components/ExportCsvButton/index.js